// material-ui components
import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import styles from "../../assets/jss/material-dashboard-react/components/dropDownButtonStyle";

const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) =>
  createStyles({
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

export default function DropDownShortBreakShift({ shift, setShift }) {
  const classes = useStyles();
  const classes2 = useStyles2();

  const handleChange = (event) => {
    setShift(event.target.value);
  };

  return (
    <FormControl
      variant="outlined"
      style={{ marginBottom: "30px" }}
      className={classes.formControl}
    >
      <InputLabel id="demo-simple-select-filled-label">
        Qual o período?
      </InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        onChange={handleChange}
        value={shift}
        className={classes2.selectEmpty}
      >
        <MenuItem value={"Não aplica"}>{"Não aplica"}</MenuItem>
        <MenuItem value={"Manhã"}>{"Manhã"}</MenuItem>
        <MenuItem value={"Tarde"}>{"Tarde"}</MenuItem>
        <MenuItem value={"Noite"}>{"Noite"}</MenuItem>
      </Select>
    </FormControl>
  );
}
